// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2q8or","footer":"ChangeClinic_footer__1PUdU"};